import { motion } from 'framer-motion';
import PageLayout from '@/components/layout/PageLayout';

const TermsPage = () => {
  return (
    <PageLayout>
      <section className="pb-24 pt-8" data-testid="terms-page">
        <div className="max-w-3xl mx-auto px-6">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <h1 className="font-heading text-4xl sm:text-5xl font-bold text-taxera-charcoal mb-4">
              Terms of Service
            </h1>
            <p className="text-slate-500 mb-12">Last updated: February 2026</p>

            <div className="prose prose-slate max-w-none space-y-8">
              <section>
                <h2 className="font-heading text-2xl font-bold text-taxera-charcoal">1. Scope</h2>
                <p className="text-slate-600 leading-relaxed">
                  These Terms of Service ("Terms") govern your use of the Taxera website (taxera.tech) and any related services provided by Taxera Technologies GmbH ("Taxera", "we", "us"), registered in Wollerau, Switzerland.
                </p>
                <p className="text-slate-600 leading-relaxed">
                  By accessing or using our website, you agree to these Terms. If you do not agree, please discontinue use of our services.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-taxera-charcoal">2. Account Registration</h2>
                <p className="text-slate-600 leading-relaxed">
                  Certain features of our website require account registration. You agree to:
                </p>
                <ul className="list-disc pl-6 text-slate-600 space-y-2">
                  <li>Provide accurate and complete registration information</li>
                  <li>Maintain the security of your account credentials</li>
                  <li>Notify us immediately of any unauthorized access</li>
                  <li>Accept responsibility for all activity under your account</li>
                </ul>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-taxera-charcoal">3. Acceptable Use</h2>
                <p className="text-slate-600 leading-relaxed">You agree not to:</p>
                <ul className="list-disc pl-6 text-slate-600 space-y-2">
                  <li>Use the website for any unlawful purpose</li>
                  <li>Attempt to gain unauthorized access to our systems</li>
                  <li>Transmit malicious code or interfere with the website's operation</li>
                  <li>Scrape, crawl, or harvest data without written consent</li>
                  <li>Impersonate any person or entity</li>
                </ul>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-taxera-charcoal">4. Intellectual Property</h2>
                <p className="text-slate-600 leading-relaxed">
                  All content on this website — including text, graphics, logos, software, and data — is the property of Taxera Technologies GmbH or its licensors and is protected by Swiss and international intellectual property laws. You may not reproduce, distribute, or create derivative works without our express written consent.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-taxera-charcoal">5. Calculator & Estimates</h2>
                <p className="text-slate-600 leading-relaxed">
                  The compliance calculators and cost estimators on our website are provided for informational purposes only. The figures generated are estimates based on industry averages and should not be relied upon as financial advice. Actual costs may vary based on your specific circumstances.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-taxera-charcoal">6. Limitation of Liability</h2>
                <p className="text-slate-600 leading-relaxed">
                  To the maximum extent permitted by law, Taxera shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the website. Our total liability for any claim shall not exceed CHF 100.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-taxera-charcoal">7. Termination</h2>
                <p className="text-slate-600 leading-relaxed">
                  We reserve the right to suspend or terminate your access to the website at our sole discretion, without notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-taxera-charcoal">8. Governing Law</h2>
                <p className="text-slate-600 leading-relaxed">
                  These Terms are governed by the laws of Switzerland. Any disputes shall be submitted to the exclusive jurisdiction of the courts of the Canton of Schwyz, Switzerland.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-taxera-charcoal">9. Contact</h2>
                <p className="text-slate-600 leading-relaxed">
                  For questions about these Terms, contact us at:
                </p>
                <p className="text-slate-600">
                  Taxera Technologies GmbH<br />
                  Sihleggstrasse 23, 8832 Wollerau, Switzerland<br />
                  <a href="mailto:legal@taxera.tech" className="text-taxera-blue hover:underline">legal@taxera.tech</a>
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </section>
    </PageLayout>
  );
};

export default TermsPage;
